module.exports = __webpack_public_path__ + "static/media/about.54557a1e.png";